// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610071817/js/" + chunkId + "." + {"44":"f217de05","225":"254b4f56","481":"6de59c46","486":"9cb1cee7","770":"6523e4f7"}[chunkId] + ".0.7097680635783072.chunk.js";
};